import { render } from "./Edit.vue?vue&type=template&id=3801e6e4&ts=true&lang=pug"
import script from "./Edit.vue?vue&type=script&lang=ts"
export * from "./Edit.vue?vue&type=script&lang=ts"

import "./Edit.vue?vue&type=style&index=0&id=3801e6e4&lang=scss"

import exportComponent from "C:\\Users\\ZiegFreeze\\Documents\\Work\\upa-fast-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__